import { api } from '@/lib/axios';

export interface SauvegardeInfo {
  postgresql: boolean;
  sauvegarde_possible: boolean;
  base?: string;
  taille_octets?: number;
  version?: string;
}

export async function getSauvegardeInfo(): Promise<SauvegardeInfo> {
  const { data } = await api.get<SauvegardeInfo>('/sauvegarde/info');
  return data;
}

/** Télécharge un dump SQL compressé (.sql.gz) de la base. */
export async function telechargerSauvegarde(): Promise<void> {
  const res = await api.get('/sauvegarde/telecharger', { responseType: 'blob' });
  const cd = (res.headers['content-disposition'] as string | undefined) ?? '';
  const m = cd.match(/filename\*=UTF-8''([^;]+)/) ?? cd.match(/filename="?([^";]+)"?/);
  const name = m ? decodeURIComponent(m[1]) : 'sauvegarde.sql.gz';
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
